var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 14,
    fill: "none",
    role: "presentation"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.8,
    d: "m12.924 13.364 9.459-9.757c.195-.192.35-.422.456-.678a2.1 2.1 0 0 0 0-1.615 2.1 2.1 0 0 0-.456-.678 2 2 0 0 0-.656-.47 1.94 1.94 0 0 0-1.567 0c-.247.11-.47.27-.657.47L11.49 8.903 3.476.636a2 2 0 0 0-1.44-.615 2 2 0 0 0-1.44.615A2.13 2.13 0 0 0 0 2.122c0 .557.215 1.09.596 1.485l9.448 9.757c.186.2.41.36.657.47a1.94 1.94 0 0 0 1.566 0c.248-.11.471-.27.657-.47"
  })));
};
export default SvgDown;